export const worldList = {
    '稻妻': 'Inazuma',
    '蒙德': 'Mondstadt',
    '龙脊雪山': 'Dragonspine',
    '璃月': 'Liyue'
};